import { NgIf } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Input, Output ,inject} from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { Router, RouterLink } from '@angular/router';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';;

@Component({
  selector: 'iho-pdp-empty-view',
  standalone: true,
  imports: [MatRippleModule, RouterLink, NgIf],
  templateUrl: './pdp-empty-view.component.html',
  styleUrls: ['./pdp-empty-view.component.scss'],
})
export class PdpEmptyViewComponent {
  @Output() resetFilters = new EventEmitter<boolean>(false);
  @Output() openDatePicker = new EventEmitter<boolean>(false);
  @Output() goToSimilarHotelsSection = new EventEmitter<any>();
  @Input() similarHotelsLink?: string;
  @Input() cityId = '';
  @Input() hasActive = false;
  @Input() hasActiveFilter = false;
  @Input() serviceStatus: number | null = null;
  router = inject(Router);
  cdnUrl = cdnUrl;
  emitResetFilters() {
    this.resetFilters.emit(true);
  }

  openDatepicker() {
    this.openDatePicker.emit(true);
  }
  naviGateUrl(url?: string) {
    if (url) {
      let params = new HttpParams();
      let prefixUrl = url.split('?')[0];
      let UrlParams = url.split('?')[1].split('&');
      UrlParams.forEach((pair) => {
        const [key, value] = pair.split('=');
        params = params.append(key, value);
      });
      let startDate = params.get('date');
      let endDate = params.get('endDate');

      // this.router.navigate([prefixUrl], {
      //   queryParams: {
      //     date: startDate,
      //     endDate: endDate,
      //     refer: params.get('refer') || null,
      //     search_box: params.get('search_box'),
      //     city: this.cityId,
      //     type: 1,
      //   },
      // });

      this.goToSimilarHotelsSection.emit()
    }
  }
}
